"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hints = Hints;
var _react = _interopRequireWildcard(require("react"));
var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _reactRedux = require("react-redux");
var _urlJoin = _interopRequireDefault(require("url-join"));
var _index = require("../config/index");
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 400,
      flexGrow: 1
    },
    header: {
      display: 'flex',
      marginBottom: '1rem',
      backgroundColor: theme.palette.background.default
    },
    img: {
      height: 255,
      display: 'block',
      maxWidth: 400,
      overflow: 'hidden',
      width: '100%',
      objectFit: "contain"
    },
    stepper: {
      padding: 0,
      position: "sticky",
      bottom: 0,
      height: "60px",
      margin: 0
    },
    images: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%"
    },
    imagesWidth: {
      width: "80%"
    },
    paddedText: {
      paddingLeft: "35px"
    },
    description: {
      paddingLeft: "35px",
      margin: "10px 0",
      "& *": {
        all: "revert"
      }
    },
    loading: {
      height: "350px",
      width: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    flexedDisplay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer"
    }
  };
});
function Hints(_ref) {
  var _useSelector, _orderedSteps$activeS, _orderedSteps$activeS2, _orderedSteps$activeS3, _orderedSteps$activeS4;
  var type = _ref.type;
  (0, _react.useEffect)(function () {
    dispatch({
      type: "FETCH_HINTS",
      params: {
        page: type
      }
    });
  }, []);
  var hints = (_useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.productSalableReducer.hints.find(function (hint) {
      return hint.page === type;
    });
  })) === null || _useSelector === void 0 ? void 0 : _useSelector.steps;
  var orderedSteps = _lodash.default.orderBy(hints, ["position"]);
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeStep = _useState2[0],
    setActiveStep = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleNext = function handleNext() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };
  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };
  var handleStepChange = function handleStepChange(step) {
    setActiveStep(step);
  };
  var maxSteps = orderedSteps === null || orderedSteps === void 0 ? void 0 : orderedSteps.length;
  return !_lodash.default.isEmpty(orderedSteps) ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    square: true,
    elevation: 0,
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.paddedText
  }, (_orderedSteps$activeS = orderedSteps[activeStep]) === null || _orderedSteps$activeS === void 0 ? void 0 : _orderedSteps$activeS.title)), !_lodash.default.isEmpty((_orderedSteps$activeS2 = orderedSteps[activeStep]) === null || _orderedSteps$activeS2 === void 0 ? void 0 : _orderedSteps$activeS2.image["500x500"]) && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.images
  }, /*#__PURE__*/_react.default.createElement(_reactSwipeableViews.default, {
    className: classes.imagesWidth,
    axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
    index: activeStep,
    onChangeIndex: handleStepChange,
    enableMouseEvents: true
  }, orderedSteps.map(function (step, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: step === null || step === void 0 ? void 0 : step.title
    }, Math.abs(activeStep - index) <= 2 && !_lodash.default.isEmpty(step === null || step === void 0 ? void 0 : step.image["500x500"]) ? /*#__PURE__*/_react.default.createElement("img", {
      className: classes.img,
      src: (0, _urlJoin.default)(_index.BASE_URL, step === null || step === void 0 ? void 0 : step.image["500x500"]),
      alt: step === null || step === void 0 ? void 0 : step.title
    }) : null);
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.description,
    style: _lodash.default.isEmpty((_orderedSteps$activeS3 = orderedSteps[activeStep]) === null || _orderedSteps$activeS3 === void 0 ? void 0 : _orderedSteps$activeS3.image["500x500"]) ? {
      minHeight: "380px",
      minWidth: "360px"
    } : {},
    dangerouslySetInnerHTML: {
      __html: (_orderedSteps$activeS4 = orderedSteps[activeStep]) === null || _orderedSteps$activeS4 === void 0 ? void 0 : _orderedSteps$activeS4.description
    }
  }), /*#__PURE__*/_react.default.createElement(_MobileStepper.default, {
    steps: maxSteps,
    position: "static",
    className: classes.stepper,
    variant: "text",
    activeStep: activeStep,
    nextButton: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      size: "small",
      onClick: activeStep !== maxSteps - 1 && handleNext,
      disabled: activeStep === maxSteps - 1,
      variant: "text",
      className: classes.flexedDisplay
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Next",
      defaultMessage: "Next"
    }), theme.direction === 'rtl' ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null) : /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null)),
    backButton: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      size: "small",
      onClick: activeStep !== 0 && handleBack,
      disabled: activeStep === 0,
      className: classes.flexedDisplay
    }, theme.direction === 'rtl' ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null) : /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null), /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Back",
      defaultMessage: "Back"
    }))
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loading
  }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: "bars",
    color: "black"
  }));
}